import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { ConstService } from 'app/shared/services/const.service';
import {FormHelper} from '../../helpers/form.helper';
import {PricingMethods} from '../../enums/pricing-methods.enum';
import { DeliveryMethodsValidator } from './deliverymethods.validator';
import { TranslateService } from '@ngx-translate/core';
import { PriceComponent, PriceComponentService } from '../../api';
import { KeyValuePair, ValidationMessage } from '@tymes4-shared';

@Component({
    selector: 'app-edit-delivery-methods-form',
    templateUrl: './edit-delivery-methods-form.component.html',
    standalone: false
})
export class EditDeliveryMethodsFormComponent implements OnInit {

  public form!: FormGroup;
  public pricecomponents: Array<PriceComponent> = [];

  public isSystemDeliveryMethod: boolean = false;
  public isShopDelivery: boolean = false;
  public isEditMode: boolean = false;


  public pricingMethods = [
    {id: PricingMethods.PER_ORDER, text: this.translate.instant('DIALOGS.EDIT-DELIVERY-METHODS.FORM.DROPDOWN.PER-ORDER')},
    {id: PricingMethods.PER_LINE, text: this.translate.instant('DIALOGS.EDIT-DELIVERY-METHODS.FORM.DROPDOWN.PER-ORDER-LINE')},
    {id: PricingMethods.PER_CUSTOMER, text: this.translate.instant('DIALOGS.EDIT-DELIVERY-METHODS.FORM.DROPDOWN.PER-TICKET-RELATION')},
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<EditDeliveryMethodsFormComponent>,
              public priceComponentService: PriceComponentService,
              private deliveryMethodsValidator: DeliveryMethodsValidator,
              public constants: ConstService,
              private translate: TranslateService) {
  }

  validationMessages: KeyValuePair<ValidationMessage[]> = {};
  ngOnInit() {
      this.isEditMode = !!(this.passedData.payload && this.passedData.payload !== null);
      this.isSystemDeliveryMethod = (this.passedData.payload && this.passedData.payload !== null ? this.passedData.payload.IsSystemMethod : false);
      this.isShopDelivery = (this.passedData.payload && this.passedData.payload !== null ? this.passedData.payload.Code == 'E-TICKET' : false);


      this.form = new FormGroup({
        Id: new FormControl(0), // to preserve value
        Name: new FormControl({ value: '', disabled: this.isSystemDeliveryMethod }, [Validators.required]),
        Code: new FormControl({ value: '', disabled: this.isSystemDeliveryMethod || this.isEditMode }, { validators: [Validators.required], asyncValidators: [this.deliveryMethodsValidator.deliverMethodCodeTaken.bind(this)], updateOn: "blur" }),
        TranslationCode: new FormControl('', [Validators.required]),
        DefaultPricingMethodId: new FormControl(null, [Validators.required]),
        IsPrintDefault: new FormControl({ value: false, disabled: this.isSystemDeliveryMethod }, []),
        AvailableUntilHoursBeforeEvent: new FormControl({ value: null, disabled: this.isSystemDeliveryMethod }, []),
        AvailableFromHoursBeforeEvent: new FormControl({ value: null, disabled: this.isSystemDeliveryMethod }, []),
        DefaultEnabled: new FormControl({ value: false, disabled: this.passedData.payload ? (this.passedData.payload.Code === 'E-TICKET') : false }, []),
        CreateHardCard: new FormControl({ value: false, disabled: this.isSystemDeliveryMethod }, []),
        Price: new FormControl(null, [Validators.required]),
        PriceComponentId: new FormControl(null, [Validators.required]),
        Instruction: new FormControl(''),
        ShowInShop: new FormControl({ value: false, disabled: this.isShopDelivery }, []),
        ShowInBusinessShop: new FormControl({ value: false, disabled: this.isShopDelivery }, []),
        ShowExternal: new FormControl({ value: false, disabled: this.isShopDelivery }, []),
        DefaultEnabledBusinessShop: new FormControl({ value: false, disabled: this.passedData.payload ? (this.passedData.payload.Code === 'DISTRIBUTION') : false }, []),
        Active: new FormControl({ value: true, disabled: this.isSystemDeliveryMethod }, []),
      });


      this.priceComponentService.getManagedPriceComponents('DMS').subscribe((data: Array<PriceComponent>) => {
        this.pricecomponents = data;
      });

      if (this.passedData.payload) {
        this.deliveryMethodsValidator.editingObject = this.passedData.payload;
        this.form.patchValue(this.passedData.payload);
      }

  }

  checkDefaultsChecksEnabled(isBusiness: boolean) {
    const data = this.passedData.payload;

    return isBusiness ? data.Code === 'DISTRIBUTION' : data.Code === 'E-TICKET';
  }

  submit() {
    const value = this.form.getRawValue();
    value.IsSystemMethod = this.isSystemDeliveryMethod;
    value.IsPrintDefault = !!value.IsPrintDefault;
    value.DefaultEnabled = !!value.DefaultEnabled;
    value.CreateHardCard = !!value.CreateHardCard;
    value.ShowInShop = !!value.ShowInShop;
    value.ShowInBusinessShop = !!value.ShowInBusinessShop;
    value.ShowExternal = !!value.ShowExternal;
    value.DefaultEnabledBusinessShop = !!value.DefaultEnabledBusinessShop;
    value.Active = !!value.Active;
    this.dialogRef.close(value);
  }
}
